<div class="flex--column flex--nowrap shop flex__child--auto overflow-auto">
  <div class="wrapper--spacing-horizontal">
    <div *ngIf="(location$ | async) && (customer$ | async)" class="flex flex--justify-space-between flex--align-end">
      <agr-location-summary [location]="location$ | async" [customer]="customer$ | async" [title]="'title' | translate"></agr-location-summary>

      <product-return-button data-test="shop__return-button"></product-return-button>
    </div>

    <p class="title-catalog-card">
      {{ 'app.for-you.first-word' | translate }} <span class="title-catalog-card__second-part">{{ 'app.for-you.second-word' | translate }}</span>
    </p>

    <div class="for-you-shortcuts">
      <app-search-favorites *ngIf="isFavoritesEnabled$ | async" [isMainPageButton]="true"></app-search-favorites>
      <button class="silo-page-button" routerLink="/silos" mat-stroked-button data-test="silo-page-button">
        <mat-icon class="silo-page-button__icon">home</mat-icon>
        <span class="silo-page-button__title">{{ 'app.pages.silos' | translate }}</span>
      </button>
      <app-repeat-order-teaser></app-repeat-order-teaser>
    </div>

    <div class="spacing--margin-top">
      <div *ngIf="hasOrderBlock$ | async; else searchCard">
        <mat-divider></mat-divider>
        <app-customer-blocked-notification></app-customer-blocked-notification>
      </div>

      <ng-template #searchCard>
        <mat-divider></mat-divider>
        <app-catalog></app-catalog>
      </ng-template>
    </div>
  </div>
</div>
